import { TextField, TextFieldProps } from "@mui/material";
import {
  Controller,
  FieldPath,
  FieldValues,
  get,
  useFormContext,
} from "react-hook-form";
import { getErrorMessage } from "../fieldTypes";

type TextProps<FormValues extends FieldValues = FieldValues> = Omit<
  TextFieldProps,
  "name"
> & {
  name: FieldPath<FormValues>;
  label: string;
  disabled?: boolean;
};

const Text = <FormValues extends FieldValues = FieldValues>({
  name,
  label,
  disabled = false,
  ...rest
}: TextProps<FormValues>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  const error = get(errors, name) as unknown;
  const errorMsg = getErrorMessage(error);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <TextField
          onChange={onChange}
          value={value}
          fullWidth
          size="small"
          disabled={disabled}
          label={label}
          error={!!error}
          helperText={errorMsg}
          {...rest}
        />
      )}
    />
  );
};

export { Text };
